/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
import type { ISearchBoxStyles } from '@fluentui/react'

export const searchBoxStyles: ISearchBoxStyles = {
	root: { margin: '8px' },
}
